"use client";

import React from "react";
import { cn } from "@/lib/utils";

export default function TransformCounter({
  digit,
  className,
}: {
  digit: number;
  className?: string;
}) {
  const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <div
      className={cn(
        "relative overflow-clip w-[5rem] lg:w-[7rem] h-text-[7rem] lg:h-[12rem]",
        className
      )}
    >
      <div className="flex flex-col">

      {numbers.map((number, index) => (
        <span
          key={index}
          className={cn(
            "absolute left-1/2 -translate-x-1/2 block text-white !font-geistmono text-[7rem] lg:text-[12rem] leading-[100%] text-center transition-all duration-500",
            digit === number ? "top-0" : "top-full"
          )}
        >
          {number}
        </span>
      ))}
      </div>
    </div>
  );
}
